import * as dotenv from 'dotenv';

dotenv.config();

/**
 * API URL
 */
export const API = process.env.REACT_APP_API;

/**
 * Node environment
 */
export const NODE_ENV = process.env.NODE_ENV;

/**
 * Base url with stage
 */
// export const baseUrl = `${API}${NODE_ENV === 'development' ? 'dev' : 'prod'}`;
export const baseUrl = `${API}`;

/**
 * Quote
 */
export const quotationUrl = {
  quotation: '/crearCotizacion',
  fasecoldaCode: '/numeroFasecolda/',
  quoteResume: '/obtenerCotizacion/',
  stateInsurer: '/verificarCotizacion/',
  stateInsurerClient: '/verificarCotizacionCliente/',
  validateQuotation: '/validarPlaca/',
  validateOpportunity: '/validarOportunidad/',
  refFasecolda: '/obtenerGuiaFasecolda/',
  resetBot: '/reiniciar/',
  resetBotHVD: '/reiniciarHVD/',
  resetBotMoto: '/reiniciarMotos/',
  interestValueRate: '/obtenerTasa/',
  getLinkOffer: '/generarLink',
  getOffer: '/obtenerOferta/',
  metrics: '/metricas',
  getSegments: '/obtenerSegmentos',
};

/**
 * Cotización masiva interna (solo admin, auth Cognito)
 */
export const bulkQuotationUrl = {
  create: '/crearCotizacionLoteInterno',
  status: '/cotizacionLoteInterno/',
};

/**
 * Upload fasecolda files
 */
export const fasecoldaUrl = {
  urlUpload: '/urlUpload',
};

/**
 * Admin users control
 */
export const userControl = {
  cognitoUsers: '/cognitoUsers',
  cotizacionesUsers: '/cotizaciones',
};

/**
 * Tasas CrediSeguro
 */
export const tasasCrediseguroUrl = {
  tasas: '/tasasCrediseguro',
};
